import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-fi-bs-grid",
  "use": "icon-fi-bs-grid-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-fi-bs-grid\"><path d=\"M6.5,24H3a3,3,0,0,1-3-3V17.5H6.5Z\" /><path d=\"M21,24H17.5V17.5H24V21A3,3,0,0,1,21,24Z\" /><rect y=\"8.75\" width=\"6.5\" height=\"6.5\" /><rect x=\"17.5\" y=\"8.75\" width=\"6.5\" height=\"6.5\" /><path d=\"M6.5,6.5H0V3A3,3,0,0,1,3,0H6.5Z\" /><rect x=\"8.75\" y=\"17.5\" width=\"6.5\" height=\"6.5\" /><rect x=\"8.75\" y=\"8.75\" width=\"6.5\" height=\"6.5\" /><rect x=\"8.75\" width=\"6.5\" height=\"6.5\" /><path d=\"M24,6.5H17.5V0H21a3,3,0,0,1,3,3Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/fi-bs-grid.svg
// module id = OG+y
// module chunks = 63